module.exports = __webpack_public_path__ + "img/20wjhz-rar zip.f337c35b.svg";